export var valuesTokenOperation = ["Current", "Next", "Prev"];
/*

*/ 
//# sourceMappingURL=TokenOperation.js.map